<template>
  <div class="watermark-wrap">
    <slot></slot>
    <div v-if="content" class="watermark-layer" :style="layerStyle"></div>
  </div>
</template>

<script lang="ts" setup>
  import { computed } from 'vue'

  const props = withDefaults(
    defineProps<{
      content?: string
      width?: number
      height?: number
      rotate?: number
      font?: string
      fillStyle?: string
      gap?: [number, number]
    }>(),
    {
      content: '',
      width: 200,
      height: 120,
      rotate: -22,
      font: '14px Arial',
      fillStyle: 'rgba(0, 0, 0, 0.08)',
      gap: () => [200, 200]
    }
  )

  const getWatermarkUrl = () => {
    const canvas = document.createElement('canvas')
    const ctx = canvas.getContext('2d')
    const [gapX, gapY] = props.gap
    canvas.width = props.width + gapX
    canvas.height = props.height + gapY

    if (!ctx) return ''

    ctx.translate(canvas.width / 2, canvas.height / 2)
    ctx.rotate((Math.PI / 180) * props.rotate)
    ctx.font = props.font
    ctx.fillStyle = props.fillStyle
    ctx.textAlign = 'center'
    ctx.textBaseline = 'middle'
    ctx.fillText(props.content, 0, 0)

    return canvas.toDataURL()
  }

  const layerStyle = computed(() => {
    if (!props.content) return {}

    return {
      backgroundImage: `url(${getWatermarkUrl()})`,
      backgroundRepeat: 'repeat'
    }
  })
</script>

<style lang="less" scoped>
  .watermark-wrap {
    position: relative;
    display: flex;
    flex-direction: column;
    flex: 1 0 auto;
    min-height: 100%;
  }

  .watermark-layer {
    position: fixed;
    inset: 0;
    z-index: 9999;
    pointer-events: none;
  }
</style>
